'use client';

import debounce from '@utils/debounce';
import classNames from 'classnames';
import {
    FC,
    ForwardedRef,
    forwardRef,
    PropsWithoutRef,
    useMemo,
    useRef,
    useState,
} from 'react';
import {mergeRefs} from 'react-merge-refs';
import Scrollbar, {ScrollbarProps} from 'react-scrollbars-custom';
import styles from './MeinScrollbar.module.css';

export type MeinScrollbar = Scrollbar & HTMLDivElement;
export const MeinScrollbar = forwardRef(function MeinScrollbar(
    {className, children, ...props}: PropsWithoutRef<ScrollbarProps>,
    forwardedRef: ForwardedRef<MeinScrollbar>,
) {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef<MeinScrollbar>(null);
    const hideAfterSomeTime = useMemo(
        () =>
            debounce(() => {
                setIsVisible(false);
            }, 2000),
        [],
    );

    const showScroll = () => {
        setIsVisible(true);
        hideAfterSomeTime();
    };

    return (
        <Scrollbar
            ref={mergeRefs([ref, forwardedRef])}
            onMouseMove={showScroll}
            onScroll={showScroll}
            removeTrackYWhenNotUsed={false}
            disableTrackYWidthCompensation
            className={classNames(
                styles.scroll,
                {
                    [styles.scrollVisible]: isVisible,
                },
                className,
            )}
            {...props}
        >
            {children}
        </Scrollbar>
    );
}) as FC<ScrollbarProps>;
